export default __webpack_public_path__ + "static/1-b68995f21c022eb976281b81110d7b82.jpeg";